'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPreview = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _DataLayer = require('components/DataLayer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildProduct = function buildProduct(product) {
  var productDataLayerAttr = (0, _DataLayer.productAttrForDataLayer)({ product: product, categoryTitle: product.mainCategory, listValue: 'search' });
  var newProductEl = document.createElement('article');
  newProductEl.classList.add('collection__product-search', 'not-zero-opacity');
  newProductEl.innerHTML = '<a href="/products/' + product.handle + '" data-product-link=\'' + productDataLayerAttr + '\'>\n        <div class="collection__product-image-container-search"  tabindex="0" role="link">\n          <img class="collection__product-main-image-search" alt="' + product.title + '" src="' + product.featured_image.url + '" />\n        </div>\n        <h2 class="collection__product-title">' + product.title + '</h2>\n        <div class="yotpo bottomLine"\n          data-product-id="' + product.id + '">\n        </div>\n        <p class="collection__product-price">$' + Math.trunc(product.price) + '</p>\n      </a>';
  return newProductEl;
};

var buildResult = function buildResult(res, searchTerm) {
  var newProductEl = document.createElement('p');
  newProductEl.classList.add('search-result');
  newProductEl.innerHTML = res.length > 6 ? 'Showing 6 of ' + res.length + ' results <a href="/search?q=' + searchTerm + '">See All</a>' : 'Showing ' + res.length + ' of ' + res.length + ' results';
  return newProductEl;
};

var searchPreview = exports.searchPreview = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var searchTerm;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            $('.search-results-box').html('');
            searchTerm = $('.windows-form__input.windows-form__text')[0].value;

            if (!searchTerm) $('.results-box').html('');
            $.getJSON('/search/suggest.json', {
              q: searchTerm,
              resources: {
                type: 'product',
                options: {
                  unavailable_products: 'last'
                }
              }
            }).done(function (response) {
              $('.search-results-box').html('');
              $('.results-box').html('');
              if (response.resources.results.products && response.resources.results.products.length > 0) {
                var results = response.resources.results.products;
                results = results.filter(function (product) {
                  return !product.title.toLowerCase().includes("double");
                });
                results.slice(0, 6).forEach(function (product) {
                  $('.search-results-box')[0].append(buildProduct(product));
                });
                $('.results-box')[0].append(buildResult(results, searchTerm));
              }
            });

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function searchPreview() {
    return _ref.apply(this, arguments);
  };
}();